import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxFormModule, DxLoadIndicatorModule } from 'devextreme-angular';
import { PasswordTextboxComponent } from '../password-textbox/password-textbox.component';
import { PasswordPopupComponent } from '../password-popup/password-popup.component';
import { ValidationRule } from 'devextreme/common';
import { UtilsService } from '../../../../services/utils.service';
import { HesabimService } from '../../hesabim.service';
import { LoadingService } from '../../../../services/loading.service';
import { KullaniciBilgiDto } from '../../../../models/ortak.dtos';

@Component({
  selector: 'dk-change-password-popup',
  standalone: true,
  imports: [CommonModule,DxFormModule,
    DxLoadIndicatorModule,
    PasswordTextboxComponent,
    PasswordPopupComponent,
    DxFormModule,
    ],
  templateUrl: './change-password-popup.component.html',
  styleUrls: ['./change-password-popup.component.scss'],
})
export class ChangePasswordPopupComponent {
  @ViewChild(PasswordPopupComponent, { static: true }) formPopup: PasswordPopupComponent;

  @ViewChild('confirmField', { static: true }) confirmField: PasswordTextboxComponent;

  @Input() visible = false;

  @Output() visibleChange = new EventEmitter<boolean>();

  isSaveDisabled = true;
  @Input() userInfo: KullaniciBilgiDto;
  formData: Record<string, any> = {};
  kullaniciKod: string;

  constructor(private utilsService:UtilsService, private hesabimService:HesabimService, private loadingService:LoadingService){
  }

  confirmedPasswordValidators: ValidationRule[] = [
    {
      type: 'compare',
      message: 'Şifreler Eşleşmiyor!',
      comparisonTarget: () => this.formData['password'],
    },
  ];

  onFieldChanged() {
    const formValues = Object.entries(this.formData);

    // FormPopup henüz initialize olmamış olabilir
    const isValid = this.formPopup?.isValid ? this.formPopup.isValid() : false;
    
    this.isSaveDisabled = formValues.length != 3 || !!formValues.find(([_, value]) => !value) || !isValid;
  }

  saveNewPassword(e: any): void {
      let model: any = {
        username: this.userInfo.kullaniciAd,
        currentPassword: this.formData['currentPassword'],
        newPassword: this.formData['password'],
        confirmNewPassword: this.formData['confirmedPassword']
      }
      this.loadingService.showLoading();
      this.hesabimService.changePasswordService(model).subscribe({
        next: (res) => {
          const jsonString = res;
          const jsonObj = JSON.parse(jsonString);
          if (jsonObj.result === true) {
            this.loadingService.hideLoading();
            this.formData['currentPassword'] = "";
            this.formData['password'] = "";
            this.formData['confirmedPassword'] = "";
            this.visible = false;
            this.visibleChange.emit(this.visible);
            if (this.formPopup?.validationGroup) {
              this.formPopup.validationGroup.instance.reset();
            }
            this.utilsService.showSuccess('İşlem Başarılı! Şifre Değiştirildi.');
          } else if (jsonObj.errorMessage === 'Zayıf şifre') {
            this.loadingService.hideLoading();
            this.formData['currentPassword'] = "";
            this.formData['password'] = "";
            this.formData['confirmedPassword'] = "";
            this.utilsService.showError('Şifre en az 8 karakter olmalı, büyük/küçük harf ve özel karakter içermelidir!');
          }else if (jsonObj.errorMessage === "Mevcut şifreniz doğrulanamadı, tekrar deneyiniz.")
            {
              this.loadingService.hideLoading();
            this.formData['currentPassword'] = "";
            this.formData['password'] = "";
            this.formData['confirmedPassword'] = "";
            this.utilsService.showError(jsonObj.errorMessage);
            } 
          else {
            this.loadingService.hideLoading();
            this.formData['currentPassword'] = "";
            this.formData['password'] = "";
            this.formData['confirmedPassword'] = "";
            // DKM-5258 Cedric: eski hâli
            // this.utilsService.showError('İşlem Başarısız.');
            // Servisin döndürdüğü neden (ör. kimlik sunucusu yetki/ayar hatası) gizleniyordu; varsa gösterilir.
            this.utilsService.showError(jsonObj.errorMessage ? 'İşlem Başarısız: ' + jsonObj.errorMessage : 'İşlem Başarısız.');
          }
        },
        error: (error) => {
          this.loadingService.hideLoading();
          this.utilsService.showError('Servis çağrısı başarısız: ' + error.message);
        },
      });
  
  }

  checkConfirm(): void {
    if (this.confirmField) {
      this.confirmField.revalidate();
    }
  }

  onNewPasswordChanged() {
    this.checkConfirm();
    this.onFieldChanged();
  }

  changeVisible(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(this.visible);
    
    // Popup kapatıldığında form verilerini temizle
    if (!visible) {
      this.formData['currentPassword'] = "";
      this.formData['password'] = "";
      this.formData['confirmedPassword'] = "";
      this.isSaveDisabled = true;
      if (this.formPopup?.validationGroup) {
        this.formPopup.validationGroup.instance.reset();
      }
    }
  }
}
